const config = {
  // Firebase Settings
  firebase: {
    apiKey: 'AIzaSyCsDd5OyGwyK4jwDN0FqOlrAFZP5XjHkns',
    authDomain: 'tvtrackerapp-e68a2.firebaseapp.com',
    databaseURL: 'https://tvtrackerapp-e68a2.firebaseio.com',
    projectId: 'tvtrackerapp-e68a2',
    storageBucket: '',
    messagingSenderId: '703545240234',
  }
}

module.exports = config;


// WEBPACK FOOTER //
// ./src/config/index.js